<div class="n-oldalfej">
  <div>
    <h2>Havi számfejtés</h2>
    <span class="n-alcim">{{ aktiv.ugyfelNev || 'nincs kiválasztott ügyfél' }} · {{ honapNev(aktiv.ho) }} {{ aktiv.ev }}</span>
  </div>
  <div class="spacer"></div>
  <label class="ev-valaszto">Év
    <select [ngModel]="aktiv.ev" (ngModelChange)="evValt(+$event)"><option *ngFor="let e of evek" [ngValue]="e">{{ e }}</option></select>
  </label>
  <label class="ev-valaszto">Hónap
    <select [ngModel]="aktiv.ho" (ngModelChange)="hoValt(+$event)"><option *ngFor="let h of honapok" [ngValue]="h.value">{{ h.label }}</option></select>
  </label>
  <ion-button *ngIf="aktiv.sulinform" fill="outline" style="--color:#fff;--border-color:rgba(255,255,255,.6)" (click)="sulinformAtvesz()" [disabled]="!aktiv.ugyfelId" title="A hónap jelenléte és szabadsága a SULINFORM-ból (az összekötött alkalmazottakra)">
    <ion-icon slot="start" name="school-outline"></ion-icon>Jelenlét a SULINFORM-ból
  </ion-button>
  <ion-button *ngIf="aktiv.sulinform" fill="outline" style="--color:#fff;--border-color:rgba(255,255,255,.6)" (click)="koltsegNyit()" [disabled]="!aktiv.ugyfelId"
              title="Munkába járás km-térítése és a jóváhagyott kompenzáció átvétele a SULINFORM-ból">
    <ion-icon slot="start" name="car-outline"></ion-icon>Térítés a SULINFORM-ból
  </ion-button>
  <input #beoFile type="file" accept=".beo,.csv,text/plain" hidden (change)="beoImport($event)">
  <ion-button fill="outline" style="--color:#fff;--border-color:rgba(255,255,255,.6)" (click)="beoFile.click()" [disabled]="!aktiv.ugyfelId" title="RLB jelenléti .beo import">
    <ion-icon slot="start" name="cloud-upload-outline"></ion-icon>.beo import
  </ion-button>
  <ion-button fill="outline" style="--color:#fff;--border-color:rgba(255,255,255,.6)" (click)="szamol()" [disabled]="!aktiv.ugyfelId">
    <ion-icon slot="start" name="refresh-outline"></ion-icon>Újraszámol
  </ion-button>
  <ion-button fill="outline" style="--color:#fff;--border-color:rgba(255,255,255,.6)" (click)="hokoziNyit()" [disabled]="!elonezet.length"
              title="Hónap közbeni kifizetés (előleg, kilépő elszámolása) – a hónap zárása beszámítja">
    <ion-icon slot="start" name="cash-outline"></ion-icon>Hóközi kifizetés
  </ion-button>
  <ion-button (click)="mentMind()" [disabled]="!elonezet.length"><ion-icon slot="start" name="save-outline"></ion-icon>Összes mentése</ion-button>
</div>

<div class="ures" *ngIf="!aktiv.ugyfelId"><ion-icon name="business-outline"></ion-icon>Válassz ügyfelet (Törzsadatok → Ügyfelek).</div>

<div class="tabla-wrap" *ngIf="aktiv.ugyfelId && elonezet.length">
  <table class="n-racs">
    <thead>
      <tr>
        <th>Alkalmazott</th><th>Munkakör</th>
        <th class="num">Bruttó</th><th class="num cs-afa">SZJA</th><th class="num cs-afa">TB (18,5%)</th>
        <th class="num">Cs. kedv.</th><th class="num">Letiltás</th><th class="num cs-penz">Nettó</th>
        <th class="num cs-afa">{{ aktiv.kivas ? 'KIVA' : 'Szocho' }}</th><th class="num">Összköltség</th><th>Állapot</th><th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let e of elonezet">
        <td><b>{{ e.alkalmazott_nev }}</b>
          <span class="cimke sarga" *ngIf="e.hokoziek" [title]="'A hónapban ' + e.hokoziek + ' hóközi kifizetés – a sor a maradékot mutatja (göngyölítve)'">hóközi: {{ e.hokoziek }}</span>
          <span class="cimke" *ngIf="e.megbizas" [class.zold]="e.megbizas.biztositott"
                [title]="'Megbízás (Tbj. 6. § (1) f): járulékalap ' + (e.megbizas.jarulekalap | number:'1.0-0') + ' Ft, küszöb ' + (e.megbizas.kuszob | number:'1.0-0') + ' Ft (a minimálbér 30%-a' + (e.megbizas.napok < e.megbizas.honap_napok ? ', ' + e.megbizas.napok + ' naptári napra arányosítva' : '') + ')' + (e.megbizas.biztositott ? ' – 08E bejelentés kell' : ' – nincs TB-járulék, nem kell bejelenteni')">{{ e.megbizas.biztositott ? 'biztosított' : 'nem biztosított' }}</span></td>
        <td>{{ e.munkakor || '—' }}</td>
        <td class="num">{{ e.brutto | number:'1.0-0' }}</td>
        <td class="num cs-afa">{{ e.szja | number:'1.0-0' }}</td>
        <td class="num cs-afa">{{ e.tb_jarulek | number:'1.0-0' }}</td>
        <td class="num">{{ (e.csaladi_kedvezmeny + e.csaladi_jarulekkedv) | number:'1.0-0' }}</td>
        <td class="num">{{ e.letiltas | number:'1.0-0' }}</td>
        <td class="num cs-penz"><b>{{ e.netto | number:'1.0-0' }}</b>
          <div class="halvany" style="font-size:11px" *ngIf="+e.letiltas > 0" title="A kifizetés letiltás nélkül">letiltás nélkül: {{ (+e.netto + +e.letiltas) | number:'1.0-0' }}</div></td>
        <td class="num cs-afa">{{ e.szocho | number:'1.0-0' }}</td>
        <td class="num">{{ e.koltseg | number:'1.0-0' }}</td>
        <td><span class="cimke" [class.zold]="e.allapot === 'veglegesitett'" [class.sarga]="e.allapot === 'tervezet'">
          {{ e.allapot === 'veglegesitett' ? 'végleges' : (e.allapot === 'tervezet' ? 'tervezet' : 'nincs mentve') }}</span></td>
        <td class="ber-muv">
          <button type="button" class="kv-mini" title="Jelenlét" (click)="jelNyit(e)"><ion-icon name="time-outline"></ion-icon></button>
          <button type="button" class="kv-mini" title="Egyéb tételek (prémium, jutalom, levonás)" (click)="egyebNyit(e)"><ion-icon name="add-circle-outline"></ion-icon></button>
          <button type="button" class="kv-mini" title="Mentés" (click)="mentEgy(e)"><ion-icon name="save-outline"></ion-icon></button>
          <button type="button" class="kv-mini" title="Bérlap" (click)="berlap(e)" [disabled]="!e.mentett_id"><ion-icon name="document-text-outline"></ion-icon></button>
          <button type="button" class="kv-mini" title="Véglegesítés" *ngIf="e.allapot !== 'veglegesitett'" (click)="veglegesit(e)"><ion-icon name="lock-closed-outline"></ion-icon></button>
          <button type="button" class="kv-mini" title="Vissza tervezetté" *ngIf="e.allapot === 'veglegesitett'" (click)="vissza(e)"><ion-icon name="lock-open-outline"></ion-icon></button>
          <button type="button" class="kv-torol" title="Számfejtés törlése (a letiltás havi levonásával együtt)" *ngIf="e.mentett_id && e.allapot !== 'veglegesitett'"
                  (click)="szamfejtesTorol(e)"><ion-icon name="trash-outline"></ion-icon></button>
        </td>
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <td colspan="2">Összesen</td>
        <td class="num">{{ osszeg('brutto') | number:'1.0-0' }}</td>
        <td class="num cs-afa">{{ osszeg('szja') | number:'1.0-0' }}</td>
        <td class="num cs-afa">{{ osszeg('tb_jarulek') | number:'1.0-0' }}</td>
        <td class="num"></td><td class="num">{{ osszeg('letiltas') | number:'1.0-0' }}</td>
        <td class="num cs-penz">{{ osszeg('netto') | number:'1.0-0' }}</td>
        <td class="num cs-afa">{{ osszeg('szocho') | number:'1.0-0' }}</td>
        <td class="num">{{ osszeg('koltseg') | number:'1.0-0' }}</td>
        <td colspan="2"></td>
      </tr>
    </tfoot>
  </table>
</div>

<div class="ures" *ngIf="aktiv.ugyfelId && szamitva && !elonezet.length">
  <ion-icon name="calculator-outline"></ion-icon>Nincs aktív jogviszony ehhez az ügyfélhez. Vegyél fel jogviszonyt az Alkalmazottaknál.
</div>

<!-- Jelenlét -->
<ion-modal #jelModal cssClass="ber-urlap-modal ber-szeles-modal" (didDismiss)="jelZarEngedi()">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej"><ion-title>Jelenlét – {{ jelSzerk?.alkalmazott_nev }} · {{ honapNev(aktiv.ho) }} {{ aktiv.ev }}</ion-title>
      <ion-buttons slot="end"><ion-button (click)="jelModal.dismiss()">Bezár</ion-button></ion-buttons></ion-toolbar></ion-header>
    <div class="nk-torzs">
      <div class="nk-form" *ngIf="jelSzerk">
        <app-szerk-zar-sav [zar]="zarJel"></app-szerk-zar-sav>
        <div class="jel-fej">
          <div class="jel-fulek" *ngIf="jelAlk">
            <button type="button" [class.aktiv]="jelMod === 'napok'" (click)="jelMod = 'napok'"><ion-icon name="calendar-outline"></ion-icon>Napok</button>
            <button type="button" [class.aktiv]="jelMod === 'osszesito'" (click)="jelMod = 'osszesito'"><ion-icon name="list-outline"></ion-icon>Havi órák kézzel</button>
          </div>
          <span class="cimke" *ngIf="jelAlk?.kotott" title="A napok a SULINFORM jelenléti naplójából jönnek, és mentéskor oda visszaíródnak">SULINFORM · visszaíródik</span>
          <span class="cimke" *ngIf="jelKep">{{ jelKep.naptar.munkanapok }} munkanap</span>
          <span class="cimke" *ngIf="jelAlk?.keretek?.szabadsag_keret != null">Szabadság az évben: {{ jelAlk.keretek.szabadsag_kivett }} / {{ jelAlk.keretek.szabadsag_keret }} nap</span>
          <span class="cimke" *ngIf="jelAlk">Betegszabadság a hónap előtt: {{ jelAlk.keretek.beteg_elotte }} / {{ jelAlk.keretek.beteg_keret }} nap</span>
        </div>

        <ng-container *ngIf="jelMod === 'napok' && jelKep">
          <div class="jel-ecsetek">
            <button type="button" *ngFor="let st of statuszLista" class="jel-ecset" [attr.data-st]="st.k" [class.aktiv]="ecset === st.k" (click)="ecset = st.k">
              <i></i>{{ st.n }}</button>
            <span class="spacer"></span>
            <button type="button" class="ov-gomb" (click)="uresMunkanapKitolt()" title="Az üres munkanapok Dolgozik státuszt kapnak"><ion-icon name="color-fill-outline"></ion-icon>Üres munkanapok: dolgozik</button>
          </div>
          <div class="jel-naptar">
            <div class="jel-hetnap" *ngFor="let h of ['H', 'K', 'Sze', 'Cs', 'P', 'Szo', 'V']">{{ h }}</div>
            <ng-container *ngFor="let het of jelHetek">
              <ng-container *ngFor="let n of het">
                <div *ngIf="!n" class="jel-nap jel-ures"></div>
                <button *ngIf="n" type="button" class="jel-nap" [class.pihenonap]="!n.munkanap" [attr.data-st]="jelNapok[n.datum] || 0"
                        (click)="napKattint(n)" [title]="n.datum + (n.nev ? ' – ' + n.nev : '') + ': ' + statuszNev(jelNapok[n.datum])">
                  <span class="jel-nap-sz">{{ n.nap }}</span>
                  <span class="jel-nap-st">{{ rovid(jelNapok[n.datum]) }}</span>
                  <span class="jel-nap-unnep" *ngIf="n.nev">{{ n.nev }}</span>
                </button>
              </ng-container>
            </ng-container>
          </div>
          <div class="jel-ossz" *ngIf="jelElonezet as o">
            <span><b>{{ o.ledolg }}</b> nap ledolgozott ({{ o.ledolgOra }} óra)</span>
            <span *ngIf="o.szab"><b>{{ o.szab }}</b> nap szabadság</span>
            <span *ngIf="o.betegSzab"><b>{{ o.betegSzab }}</b> nap betegszabadság (70%)</span>
            <span *ngIf="o.tappenz"><b>{{ o.tappenz }}</b> nap táppénz</span>
            <span *ngIf="o.fizNelk"><b>{{ o.fizNelk }}</b> nap fizetés nélküli</span>
            <span class="figyel" *ngIf="o.nincs"><ion-icon name="alert-circle-outline"></ion-icon>{{ o.nincs }} munkanapon nincs adat – ledolgozottnak számít</span>
          </div>
        </ng-container>

        <ng-container *ngIf="jelMod === 'osszesito'">
          <p class="halvany" style="margin:0">Üres ledolgozott óra = teljes havi munkaidő (teljes havibér). A távollétek díja a távolléti díjból számolódik.</p>
          <div class="jel-mezok">
            <label class="kv-mezo"><span>Ledolgozott órák</span><input type="number" [(ngModel)]="jelSzerk.ledolgozott_orak"></label>
            <label class="kv-mezo"><span>Ledolgozott napok</span><input type="number" [(ngModel)]="jelSzerk.ledolgozott_napok"></label>
            <label class="kv-mezo"><span>Szabadság (óra)</span><input type="number" [(ngModel)]="jelSzerk.szabadsag_orak"></label>
            <label class="kv-mezo"><span>Betegszabadság (óra)</span><input type="number" [(ngModel)]="jelSzerk.betegszabadsag_orak"></label>
            <label class="kv-mezo"><span>Táppénz (nap)</span><input type="number" [(ngModel)]="jelSzerk.tappenz_napok"></label>
            <label class="kv-mezo"><span>Fizetett távollét (óra)</span><input type="number" [(ngModel)]="jelSzerk.fizetett_tavollet"></label>
            <label class="kv-mezo"><span>Fizetés nélküli (óra)</span><input type="number" [(ngModel)]="jelSzerk.fizetes_nelkuli_orak"></label>
          </div>
        </ng-container>

        <div class="jel-mezok">
          <label class="kv-mezo"><span>Túlóra (óra)</span><input type="number" [(ngModel)]="jelSzerk.tullora"></label>
          <label class="kv-mezo"><span>Éjszakai (óra)</span><input type="number" [(ngModel)]="jelSzerk.ejszakai"></label>
          <label class="kv-mezo"><span>Vasárnapi (óra)</span><input type="number" [(ngModel)]="jelSzerk.vasarnapi"></label>
          <label class="kv-mezo"><span>Műszakpótlékos (óra)</span><input type="number" [(ngModel)]="jelSzerk.muszakpotlek"></label>
        </div>
        <div class="nk-lab">
          <span class="halvany" *ngIf="jelMod === 'napok' && jelAlk?.kotott" style="font-size:12px;margin-right:auto">Mentéskor a megváltozott napok a SULINFORM jelenléti naplójába is visszaíródnak.</span>
          <button type="button" class="ov-gomb fo" (click)="jelMent()" [disabled]="zarJel && !zarJel.irhato"><ion-icon name="save-outline"></ion-icon>Mentés és újraszámolás</button>
        </div>
      </div>
    </div>
  </ng-template>
</ion-modal>

<!-- Egyéb (eseti) tételek -->
<ion-modal #egyebModal cssClass="ber-urlap-modal ber-szeles-modal">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej"><ion-title>Egyéb tételek – {{ egyebAlk?.alkalmazott_nev }} · {{ honapNev(aktiv.ho) }} {{ aktiv.ev }}</ion-title>
      <ion-buttons slot="end"><ion-button (click)="egyebModal.dismiss()">Bezár</ion-button></ion-buttons></ion-toolbar></ion-header>
    <div class="nk-torzs">
      <div class="nk-form">
        <p class="halvany" style="margin:0">Csak erre a hónapra szóló jövedelmek és levonások. Az adózásukat a jogcím dönti el (Törzsadatok → Jogcím törzs);
          a havonta ismétlődő tételek és a nyugdíjpénztári tagság az Alkalmazotti törzsben állítható.</p>
        <table class="n-racs" *ngIf="egyebLista.length">
          <thead><tr><th>Jogcím</th><th>Megjegyzés</th><th class="num">Összeg</th><th></th></tr></thead>
          <tbody>
            <tr *ngFor="let t of egyebLista">
              <td><b>{{ t.kod }}</b> {{ t.jogcim }} <span class="cimke" [class.sarga]="t.tipus === 'levonas'" [class.zold]="t.tipus !== 'levonas'">{{ t.tipus === 'levonas' ? 'levonás' : 'jövedelem' }}</span></td>
              <td>{{ t.megjegyzes || '' }}</td>
              <td class="num">{{ t.tipus === 'levonas' ? '−' : '' }}{{ t.osszeg | number:'1.0-0' }}</td>
              <td class="ber-muv"><button type="button" class="kv-torol" (click)="egyebTorol(t)"><ion-icon name="trash-outline"></ion-icon></button></td>
            </tr>
          </tbody>
          <tfoot><tr><td colspan="2">Jövedelem / levonás</td><td class="num">{{ egyebJovedelem | number:'1.0-0' }} / −{{ egyebLevonas | number:'1.0-0' }}</td><td></td></tr></tfoot>
        </table>
        <p class="halvany" *ngIf="!egyebLista.length">Nincs eseti tétel ebben a hónapban.</p>
        <div class="egyeb-uj">
          <select [(ngModel)]="egyebUj.jogcim_id"><option *ngFor="let j of egyebJogcimek" [ngValue]="j.id">{{ j.kod }} – {{ j.nev }}{{ j.tipus === 'levonas' ? ' (levonás)' : '' }}</option></select>
          <input type="number" [(ngModel)]="egyebUj.osszeg" placeholder="Összeg (Ft)">
          <input type="text" [(ngModel)]="egyebUj.megjegyzes" placeholder="Megjegyzés">
          <button type="button" class="ov-gomb fo" [disabled]="!egyebUj.jogcim_id || !(egyebUj.osszeg > 0)" (click)="egyebHozzaad()"><ion-icon name="add"></ion-icon>Hozzáad</button>
        </div>
      </div>
    </div>
  </ng-template>
</ion-modal>

<!-- A hónap kifizetései (hóközi + záró) – akkor látszik, ha volt hóközi kifizetés. -->
<div class="tabla-wrap" *ngIf="hokoziSorok.length">
  <table class="n-racs">
    <thead><tr><th>A hónap kifizetései</th><th>Időszak</th><th>Kifizetve</th><th class="num">Bruttó</th><th class="num">SZJA</th><th class="num">TB</th><th class="num cs-penz">Nettó</th><th></th></tr></thead>
    <tbody>
      <tr *ngFor="let r of hokoziSorok">
        <td><b>{{ r.alkalmazott_nev }}</b> <span class="cimke" [class.zold]="r.tipus === 'havi'">{{ r.tipus === 'havi' ? 'havi zárás' : (r.megnevezes || 'hóközi') }}</span></td>
        <td>{{ r.tol ? (r.tol + ' – ' + (r.ig || '')) : '—' }}</td>
        <td>{{ r.kifizetes || '—' }}</td>
        <td class="num">{{ r.brutto | number:'1.0-0' }}</td>
        <td class="num">{{ r.szja | number:'1.0-0' }}</td>
        <td class="num">{{ r.tb_jarulek | number:'1.0-0' }}</td>
        <td class="num cs-penz"><b>{{ r.netto | number:'1.0-0' }}</b></td>
        <td class="ber-muv">
          <button type="button" class="kv-mini" title="Bérlap" (click)="berlap({ mentett_id: r.id })"><ion-icon name="document-text-outline"></ion-icon></button>
          <button type="button" class="kv-torol" *ngIf="r.tipus === 'hokozi' && r.allapot !== 'veglegesitett'" title="Hóközi kifizetés törlése" (click)="hokoziTorol(r)"><ion-icon name="trash-outline"></ion-icon></button>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Hóközi kifizetés rögzítése -->
<!-- Utazási költségtérítés és kompenzáció átvétele a SULINFORM-ból -->
<ion-modal #koltsegModal cssClass="ber-urlap-modal ber-szeles-modal">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej">
      <ion-title>Térítés a SULINFORM-ból – {{ honapNev(aktiv.ho) }} {{ aktiv.ev }}</ion-title>
      <ion-buttons slot="end"><ion-button (click)="koltsegModal.dismiss()">Bezár</ion-button></ion-buttons>
    </ion-toolbar></ion-header>
    <div class="nk-torzs">
      <div class="nk-form">
        <p class="halvany" style="margin:0">
          A munkába járás térítése a SULINFORM adataiból számolódik (km × a hónap „dolgozik" napjai × {{ koltseg?.ftkm || 0 }} Ft/km),
          a kompenzációból csak a JÓVÁHAGYOTT tételek jönnek át. A {{ koltseg?.km_adomentes || 30 }} Ft/km-ig terjedő rész és a bérlet-térítés
          adómentes (Szja tv. 25. § (2)), és a letiltás alapjába sem számít bele (Vht. 74. § i); a fölötte lévő rész bérként adózik.
          Az átvétel újrafuttatható: a korábban átvett sorokat felülírja, a kézzel rögzített tételekhez nem nyúl.
        </p>

        <div class="n-szuro-sor" *ngIf="koltseg">
          <label style="display:inline-flex;align-items:center;gap:6px"><input type="checkbox" [(ngModel)]="koltsegKer.utazas"> Utazás térítése</label>
          <label style="display:inline-flex;align-items:center;gap:6px"><input type="checkbox" [(ngModel)]="koltsegKer.kompenzacio"> Kompenzáció</label>
          <span class="spacer" style="flex:1"></span>
          <b>{{ koltsegValasztott.length }} alkalmazott · {{ koltsegVegosszeg | number:'1.0-0' }} Ft</b>
          <button type="button" class="ov-gomb fo" [disabled]="!koltsegValasztott.length" (click)="koltsegAtvesz()">
            <ion-icon name="download-outline"></ion-icon>Átvétel
          </button>
        </div>

        <p class="halvany" *ngIf="koltsegTolt">Betöltés…</p>
        <table class="n-racs" *ngIf="koltseg?.sorok?.length">
          <thead><tr>
            <th></th><th>Alkalmazott</th><th class="num">km</th><th class="num">Munkanap</th>
            <th class="num">Utazás</th><th class="num">ebből adómentes</th><th class="num">Bérlet</th><th class="num">Óra alapú</th><th class="num">Egyéb</th><th>Állapot</th>
          </tr></thead>
          <tbody>
            <tr *ngFor="let s of koltseg.sorok" [class.halvany]="!koltsegVanMit(s)">
              <td><input type="checkbox" [(ngModel)]="koltsegKijelolt[s.alkalmazott_id]" [disabled]="!koltsegVanMit(s)"></td>
              <td>{{ s.nev }} <span class="cimke">{{ s.allomany_adid }}</span></td>
              <td class="num">{{ s.utazas.km || '—' }}</td>
              <td class="num">{{ s.utazas.munkanap }}</td>
              <td class="num">{{ s.utazas.osszeg | number:'1.0-0' }}</td>
              <td class="num">{{ s.utazas.adomentes | number:'1.0-0' }}</td>
              <td class="num">{{ s.kompenzacio.berlet | number:'1.0-0' }}</td>
              <td class="num">{{ s.kompenzacio.ora | number:'1.0-0' }}</td>
              <td class="num">{{ s.kompenzacio.egyeb | number:'1.0-0' }}</td>
              <td>
                <span class="cimke zold" *ngIf="s.atveve && (s.atveve['150'] || s.atveve['151'] || s.atveve['152'] || s.atveve['153'] || s.atveve['154'])">már átvéve</span>
                <span class="cimke sarga" *ngIf="s.kompenzacio.varakozo" [title]="'Elbírálásra váró kompenzáció-tétel'">{{ s.kompenzacio.varakozo }} elbírálatlan</span>
                <span class="cimke sarga" *ngIf="s.szamfejtve" title="A hónap számfejtése már mentve – átvétel után újra kell menteni">számfejtve</span>
              </td>
            </tr>
          </tbody>
        </table>
        <p class="halvany" *ngIf="koltseg && !koltseg.sorok.length">
          Nincs SULINFORM-hoz kötött alkalmazott. Az összekötés a Törzsadatok → Alkalmazottak oldalon történik.
        </p>
      </div>
    </div>
  </ng-template>
</ion-modal>

<ion-modal #hokoziModal cssClass="ber-urlap-modal">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej">
      <ion-title>Hóközi kifizetés – {{ honapNev(aktiv.ho) }} {{ aktiv.ev }}</ion-title>
      <ion-buttons slot="end"><ion-button (click)="hokoziModal.dismiss()">Bezár</ion-button></ion-buttons>
    </ion-toolbar></ion-header>
    <div class="nk-torzs">
      <div class="nk-form" *ngIf="hokozi">
        <p class="halvany" style="margin:0;font-size:12.5px">A hónap elejétől a megadott napig göngyölítve számolunk, és levonjuk a hónapban
          már kifizetetteket – így az adó, a járulék és a kedvezmények a havi együttes jövedelemre lesznek helyesek. A hónap zárása
          (a fenti táblázat) automatikusan a maradékot mutatja.</p>
        <label class="kv-mezo"><span>Elszámolva eddig a napig</span><input type="date" [(ngModel)]="hokozi.ig"></label>
        <label class="kv-mezo"><span>Kifizetés napja</span><input type="date" [(ngModel)]="hokozi.kifizetes"></label>
        <label class="kv-mezo"><span>Megnevezés</span><input type="text" [(ngModel)]="hokozi.megnevezes" placeholder="pl. Bérelőleg"></label>
        <label class="kv-mezo"><span>Kikre</span>
          <select [(ngModel)]="hokozi.jogviszony_id">
            <option [ngValue]="null">— a hónap minden számfejtett jogviszonyára —</option>
            <option *ngFor="let e of elonezet" [ngValue]="e.jogviszony_id">{{ e.alkalmazott_nev }}{{ e.munkakor ? ' – ' + e.munkakor : '' }}</option>
          </select></label>
        <div class="nk-lab"><button type="button" class="ov-gomb fo" [disabled]="hokoziFut || !hokozi.ig" (click)="hokoziMent()">
          <ion-icon name="cash-outline"></ion-icon>{{ hokoziFut ? 'Számolás…' : 'Rögzítés' }}</button></div>
      </div>
    </div>
  </ng-template>
</ion-modal>
